import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { businessActions } from '../../business';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';
import getCurrentConfig from './getCurrent';

const actions = createActions({
  USER: {
    UPGRADE_SUBSCRIPTION: (businessName, businessSize, email, planId) => ({ businessName, businessSize, email, planId }),
    API: {
      UPGRADE_SUBSCRIPTION: apiResourceActionCreator('business')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(`${USER_RESOURCE_ENDPOINT(RESOURCES.Subscription)}/upgrade`, authToken, payload, actions.user.api.upgradeSubscription)

export function* upgradeSubscription({
  payload: {
    businessName,
    businessSize,
    email,
    planId
  }
}) {
  const authToken = yield select(authTokenSelector);
  const pendingBusiness = {
    name: businessName,
    email: email,
    uploadCpdWithoutApproval: false,
  }
  if (authToken.idToken) {
    yield put(apiAction(authToken, { pendingBusiness, businessSize, planId }))
  }

  const upgradeSubscriptionResult = yield apiActionResult(actions.user.api.upgradeSubscription);

  if (upgradeSubscriptionResult.success) {
    const businessId = upgradeSubscriptionResult.success.payload.business.id
    yield put(businessActions.business.getCpdCategorys(businessId));
    const refetchBusinessCpdCategoryResult = yield apiActionResult(businessActions.business.api.getCpdCategorys);
    if (refetchBusinessCpdCategoryResult.success) {
      yield put(getCurrentConfig.action.user.getCurrent());
      yield put(push({ pathname: routes.app.accountSettings("payment") }));
    }
  }
}

const configuration = {
  name: 'upgradeSubscription',
  action: actions,
  sagas: upgradeSubscription,
  reducers: {

  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/upgradeSubscription.js